import { render } from "./MainLayout.vue?vue&type=template&id=0e094fb5&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=0e094fb5&scoped=true&lang=css"

import exportComponent from "/Users/rithy/Documents/code/vpos.club/vpos-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e094fb5"]])

export default __exports__